import React from 'react';
import { motion } from 'framer-motion';
interface SectionWrapperProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  immediate?: boolean;
}
export function SectionWrapper({
  children,
  className = '',
  id,
  immediate = false
}: SectionWrapperProps) {
  const baseClass = `py-10 md:py-24 px-3 md:px-4 max-w-4xl mx-auto w-full ${className}`;
  if (immediate) {
    return <section id={id} className={baseClass} data-id="element-285">
        {children}
      </section>;
  }
  return <motion.section id={id} initial={{
    opacity: 0,
    y: 40
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.6,
    ease: 'easeOut'
  }} className={baseClass} data-id="element-286">
      {children}
    </motion.section>;
}